import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { SiteOverviewSite, SiteStatusSite } from "../../site-status-types";

function getOrganizationsWithProjectAccessColumn(): MRT_ColumnDef<
  SiteOverviewSite | SiteStatusSite
> {
  return {
    header: "Projektzugriff",
    accessorFn: (rowData) => rowData.organizationsWithProjectAccess.join(", "),
    enableCellHoverReveal: true,
    Cell: ({ row }) => {
      const organizationsWithProjectAccess =
        row.original.organizationsWithProjectAccess;

      if (organizationsWithProjectAccess.length === 0) {
        return "-";
      }

      if (organizationsWithProjectAccess.length === 1) {
        return organizationsWithProjectAccess[0];
      }

      return (
        <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
          {organizationsWithProjectAccess.map(
            (organizationWithProjectAccess) => (
              <li key={organizationWithProjectAccess}>
                {organizationWithProjectAccess}
              </li>
            )
          )}
        </ul>
      );
    },
    filterFn: (row, columnId, filterValue) => {
      const organizationWithProjectAccess = row
        .getValue<string>(columnId)
        .toLowerCase();
      return organizationWithProjectAccess.includes(filterValue.toLowerCase());
    }
  };
}

export { getOrganizationsWithProjectAccessColumn };
